import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { Globals } from 'src/app/service/global';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AttendeeService } from 'src/app/service/attendee.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { MeetingService } from 'src/app/service/meeting.service';



@Component({
  selector: 'app-task-title-dialog',
  templateUrl: './task-title-dialog.component.html',
  styleUrls: ['./task-title-dialog.component.css'],
  providers: [DatePipe]
})
export class TaskTitleDialogComponent implements OnInit {
  options: any
  today: any
  currentDate: any
  optionsTwo: any;
  currentDateTwo: any;
  meetingInfoData: any;
  //UI Team change
  taskStatusList: any = [];
  decisionList: any = [];
  assignedToValues: any = [];
  reAssignedToValues!: string
  reAssignedValues!: string
  // reAssignSecUserId: Event | undefined
  reAssignSecUserId: any;
  taskStatusValue: any
  taskUserId: any;
  noteDescription = new UntypedFormControl();
  disableReAssign: any;
  showEdit = true
  confirmDialogStatus!: boolean
  dueDateInfo = new UntypedFormControl();
  taskTitleInfo!: string
  reassignedId: any
  reassignedId1: any
  assignValues!: string;
  assignUserId!: any;
  valueCheck: boolean = true;
  originalAssignedTo: any = [];
  originalDueDate?: any;
  originalNoteDescription?: String;
  length: any;
  quillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
  };

  constructor(private sideNav: SideNavServiceService, private attendeeService: AttendeeService, public dialog: MatDialog, private permissionService: PermissionService, public commonMinService: FreeFormMinutesService, @Inject(MAT_DIALOG_DATA) data: any, private router: Router, private matDialogRef: MatDialogRef<TaskTitleDialogComponent>, private globals: Globals, private freeformagenda: FreeFormAgendaService, private util: UtilityService, public datepipe: DatePipe, private meetingService: MeetingService) {
    this.taskStatusList = this.globals.globaltaskStatusList;
    this.meetingInfoData = data;
    this.taskStatusValue = this.meetingInfoData.taskData.status
    this.length = this.meetingInfoData.taskData.actionItemOwner.length
    this.setData();
  }

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';

  ngOnInit(): void {
    this.options = {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }

    this.optionsTwo = {
      month: 'short',
      day: 'numberic',
      year: 'numeric'
    }
    this.today = new Date();
  }
  ngAfterViewInit() {
    this.commonMinService.activateAllCkeditor('taskTitles');
  }
  //
  taskEdit = new UntypedFormGroup({
    assignedToUpdate: new UntypedFormControl(''),
    assignedTo: new UntypedFormControl(''),
    dueDate: new UntypedFormControl(''),
    dueDateStr: new UntypedFormControl(''),
    meetingId: new UntypedFormControl(''),
    minutesId: new UntypedFormControl(''),
    taskTitle: new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    guestOwnerName: new UntypedFormControl(''),
    isPrivate: new UntypedFormControl(''),
    noteTypeId: new UntypedFormControl(''),
    noteTypeCode: new UntypedFormControl(''),
    taskId: new UntypedFormControl(''),
    taskEditFrom: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    visitorTimeZone: new UntypedFormControl(''),
    deletedFlag: new UntypedFormControl(''),
    noteDescription: new UntypedFormControl('')
  });
  setData() {
    if (this.meetingInfoData.taskData.actionItemOwner != null && this.meetingInfoData.taskData.actionItemOwner != undefined) {
      this.meetingInfoData.taskData.actionItemOwner.forEach((taskEle: any, taskIndex: any) => {
        var assignedToJson = {
          "fkCodelstStatus": taskEle.fkCodelstStatus,
          "ownerName": taskEle.ownerName,
          "fkSecUserOwner": taskEle.fkSecUserOwner,
        }
        this.assignedToValues.push(assignedToJson);
      });
    }
    this.originalAssignedTo = this.assignedToValues.map((_arrayElement: any) => Object.assign({}, _arrayElement));

    if (this.meetingInfoData.taskData.assignedTo == null || this.meetingInfoData.taskData.assignedTo == '' || this.meetingInfoData.taskData.assignedTo == 'undefined') {
      this.taskEdit.controls['assignedToUpdate'].setValue("");
    } else {
      this.taskEdit.controls['assignedToUpdate'].setValue("");
    }
    this.taskEdit.controls['dueDate'].setValue(this.meetingInfoData.taskData.dueDate);
    this.taskEdit.controls['agendaId'].setValue(this.meetingInfoData.taskData.agendaId);
    this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    this.taskEdit.controls['taskTitle'].setValue(this.meetingInfoData.taskData.taskTitle);
    this.taskEdit.controls['deletedFlag'].setValue(this.meetingInfoData.taskData.deletedFlag);
    this.taskEdit.controls['isPrivate'].setValue(this.meetingInfoData.taskData.isPrivate);
    this.taskEdit.controls['meetingId'].setValue(this.meetingInfoData.taskData.meetingId);
    this.taskEdit.controls['minutesId'].setValue(this.meetingInfoData.taskData.minutesId);
    this.taskEdit.controls['noteTypeCode'].setValue(this.meetingInfoData.taskData.noteTypeCode);
    this.taskEdit.controls['noteTypeId'].setValue(this.meetingInfoData.taskData.noteTypeId);
    this.taskEdit.controls['taskEditFrom'].setValue("MT");
    this.taskEdit.controls['taskId'].setValue(this.meetingInfoData.taskData.taskId);
    this.taskEdit.controls['userId'].setValue(this.globals.userId);
    this.taskEdit.controls['visitorTimeZone'].setValue(this.globals.vTimeZone);
    this.noteDescription.setValue(this.meetingInfoData.taskData.noteDescription);
    this.dueDateInfo = this.taskEdit.controls['dueDate'].value
    this.taskTitleInfo = this.taskEdit.controls['taskTitle'].value
    this.originalDueDate = this.datepipe.transform(this.taskEdit.controls['dueDate'].value, "MMM dd, YYYY")
    this.originalNoteDescription = this.meetingInfoData.taskData.noteDescription;
  }

  //method is used to get the current fksecuserID
  taskUser(e: any) {
    this.taskUserId = e;
  }


  updateTaskStatus(e: any) {
    var objIndex = this.assignedToValues.findIndex(((obj: { fkSecUserOwner: any; }) => obj.fkSecUserOwner == this.taskUserId));
    this.assignedToValues[objIndex].fkCodelstStatus = e.value;
  }
  updateTaskPOpup() {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.TASK, this.util.permissionType.MODIFY);
    if (!accessFlag) {
      return;
    }
    this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    this.taskEdit.controls['noteDescription'].setValue(this.noteDescription.value);
    this.taskEdit.controls['dueDateStr'].setValue(this.datepipe.transform(this.taskEdit.controls['dueDate'].value, "MMM dd, YYYY"));
    this.taskEdit.controls['taskTitle'].setValue(this.taskTitleInfo);
    var taskResponse = this.freeformagenda.updateTaskFromPopup(this.taskEdit.value);
    this.matDialogRef.close(taskResponse);
  }
  reassignTask(fkUserName: any, obj: any) {

    this.attendeeService.loadAttendeeAgendaPresenters('true', 'ATTs', obj, this.assignedToValues, []).then(($inputor: any) => {
      var pageIns = this;
      $inputor.off("inserted.atwho");
      $inputor.on("inserted.atwho", (event: any, $li: any, query: any) => {
        if ($li.length != 0) {
          $('.atwho-inserted:first', obj);
          $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");
          var assignedTo = Number($li.data('item-data').id)
          var objIndex = this.assignedToValues.findIndex((data: any) => data.fkSecUserOwner == fkUserName);
          this.assignedToValues[objIndex].fkSecUserOwner = assignedTo;
          this.assignedToValues[objIndex].ownerName = $li.data('item-data').value;
        }
      })
    });
  }
  assignToTask(index: any, fkUserName: any, obj: any) {
    this.assignValues = ""
    this.assignUserId = ""
    this.attendeeService.loadAttendeeAgendaPresenters('true', 'ATTs', obj, this.assignedToValues, []).then(($inputor: any) => {
      var pageIns = this;
      $inputor.off("inserted.atwho");
      $inputor.on("inserted.atwho", (event: any, $li: any, query: any) => {
        if ($li.length != 0) {
          $('.atwho-inserted:first', obj);

          $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");
          var assignedTo = {
            "fkCodelstStatus": 16,
            "fkSecUserOwner": Number($li.data('item-data').id),
            "ownerName": $li.data('item-data').value,
          }
          this.meetingInfoData.taskData.actionItemOwner[index].fkSecUserOwner = Number($li.data('item-data').id)
          this.meetingInfoData.taskData.actionItemOwner[index].ownerName = $li.data('item-data').value;
          this.assignedToValues.push(assignedTo);
          this.originalAssignedTo.push(Object.assign({}, assignedTo));
        }
      })
    });
  }

  commaInsertor(id: any) {
    let fieldAccess = (<HTMLInputElement>document.getElementById("reassignId" + id));
    let valueAccess = fieldAccess.value;
    let commaInsertedValue = valueAccess + ",";
    fieldAccess.value = commaInsertedValue
  }

  redirectToMeeting(meeting: any) {
    // this.triggerConfirm()
    if (meeting.meetingData.meetingStatusCode=="SCH") {
      if(meeting.meetingData.meetingStartFlag == null ){
      var req: any = { "meetingId": meeting.meetingData.meetingId, "decryptKey": localStorage.getItem("decryptKey"),meetingObj: meeting.meetingData , "isConfidential": "Y","meetingTitle": meeting.meetingData.meetingTitle,"meetingStatusCode": meeting.meetingData.meetingStatus,flag:true,meetingStartFlag:""}; 
      }else{
        this.sideNav.openInstantMeeting(true)
        var req: any = { "meetingId": meeting.meetingData.meetingId, "decryptKey": localStorage.getItem("decryptKey"), meetingObj: meeting.meetingData ,"isMeetingRunning": true,"isConfidential": "Y","meetingTitle": meeting.meetingData.meetingTitle,"meetingStatusCode": meeting.meetingData.meetingStatus,flag:true,meetingStartFlag:"Y"}; 
      }
    } else{
      var req: any = { "meetingId": meeting.meetingData.meetingId, "decryptKey": localStorage.getItem("decryptKey"),meetingObj: meeting.meetingData,  "isConfidential": "Y","meetingTitle": meeting.meetingData.meetingTitle,"meetingStatusCode": meeting.meetingData.meetingStatusCode,flag:true,showMoM : true}; 
    } 
    // this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meeting.meetingData.meetingId, "decryptKey":localStorage.getItem("decryptKey"), "isConfidential": "Y", "isMeetingRunning": true, meetingObj: meeting.meetingData, }) }, skipLocationChange: true, replaceUrl: false });
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(req) }, skipLocationChange: true, replaceUrl: false });
    this.dialog.closeAll()
  }


  addATask() {
    this.meetingInfoData.taskData.actionItemOwner.push({
      actionItemActualComplDate: null,
      complDateStr: null,
      fkCodelstStatus: 16,
      fkSecUserOwner: '',
      guestOwnerName: null,
      ismailsent: '',
      ownerName: "",
      statusDesc: "",
    })
  }

  deleteTask(index: any, id: any) {
    this.meetingInfoData.taskData.actionItemOwner.splice(index, 1)
    this.length--;
  }
  delete(index: any, id: any) {
    this.meetingInfoData.taskData.actionItemOwner.splice(index, 1)
    var objIndex = this.assignedToValues.findIndex((data: any) => data.fkSecUserOwner == id);
    this.assignedToValues.splice(objIndex, 1)
  }

  triggerConfirm() {
    if (this.originalDueDate != this.datepipe.transform(this.taskEdit.controls['dueDate'].value, "MMM dd, YYYY")) {
      this.showEdit = false;
    }
    else if (this.taskEdit.controls['assignedTo'].value != JSON.stringify(this.assignedToValues)) {
      this.showEdit = false;
    }
    else if (this.noteDescription.value != this.originalNoteDescription) {
      this.showEdit = false;
    }

    if (this.showEdit) {
      this.dialog.closeAll()
    }
    else {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialogTitle: "Save changes before closing?",
          dialogContent: "Your changes will be lost if you don't save them."
        },
      }).afterClosed().subscribe(response => {
        this.confirmDialogStatus = response ? true : false
        if (response) {
          this.updateTaskPOpup()
          this.dialog.closeAll()
        }
        else {
          this.dialog.closeAll()
        }
      });
    }
  }



  reassignClear(id: any, event: any) {
    if (event.value.length == 0) {
      var objIndex = this.originalAssignedTo.findIndex((data: any) => data.fkSecUserOwner == id);
      this.assignedToValues[objIndex].fkSecUserOwner = this.originalAssignedTo[objIndex].fkSecUserOwner;
      this.assignedToValues[objIndex].ownerName = this.originalAssignedTo[objIndex].ownerName;
    }
  }

  updateDate(date: any) {
    this.taskEdit.controls['dueDate'].setValue(date.value);
  }

  updateReAssign(event: any) {
    this.reAssignedToValues = event.target
    this.assignedToValues = this.reAssignedValues
  }
  check() {
    this.showEdit = false;
  }
   onQuillReady(quill: any) {
      try {
        quill.on('text-change', () => {
          try { this.taskTitleInfo = quill.root.innerHTML; } catch {}
        });
      } catch {}
    }
}
